import { Button } from "@/components/ui/button/button";

import { useUpdateButton } from "./hooks/use-update-button";

export const HeaderUpdateButton = () => {
	const { isValid, onUpdate } = useUpdateButton();

	return (
		<Button variant={isValid ? "default" : "disabled"} size={"xl"} onClick={onUpdate}>
			保存
		</Button>
	);
};
